
import styles from '../styles/Layout.module.css'

const Layout = ({ children }) => {
  return (
    <div>
      <div>{children}</div>
    </div>
  );
}

export default Layout;